import { questionType, typeMapping } from '@dygc/question'

export const controlAsideTypes = [
  {
    label: '选择题',
    values: [
      {
        label: typeMapping.get(questionType.SINGLE_CHOICE),
        value: questionType.SINGLE_CHOICE,
        icon: 'icon-danxuanti'
      },
      {
        label: typeMapping.get(questionType.MULTIPLE_CHOICE),
        value: questionType.MULTIPLE_CHOICE,
        icon: 'icon-duoxuanti'
      },
      {
        label:  '量表陷阱',//typeMapping.get(questionType.NPS_SCALE),
        value: questionType.NPS_SCALE,
        icon: 'icon-NPSliangbiao'
      },

    ]
  }
]
